<template >
  <div id="app">
    <v-card class='topBar rounded-t-xl'>
      <v-list class="topBarList">
        <v-list-item style="max-height: 5vh">
          <v-avatar @click="reCenterMap">
            <v-img
                :src="require('@/assets/logo_opt3.png')"
            ></v-img>
          </v-avatar>
          <v-spacer></v-spacer>
          <img src="@/assets/nomadmap_header_black.png" alt="Nomad Map" @click="refreshApp" style="height: 55px; transform: translateY(3px)">
<!--          <v-list-item-title class="headerText" @click="refreshApp" >NomadMap</v-list-item-title>-->
          <v-spacer></v-spacer>
          <UserCard v-if="store.state.userCardLoaded"></UserCard>
        </v-list-item>
      </v-list>
    </v-card>
    <v-btn fab x-small color="white" :class="['reCenterBtn', { 'downOffset': $store.state.hotSpotsChipsState }]" @click="reCenterMap"><v-icon small>mdi-crosshairs</v-icon></v-btn>
    <v-chip-group class="categoryChipsGroup" v-if="store.state.hotSpotsChipsState" >
      <v-chip v-for="hotSpotType in this.hotSpotTypes" :key=hotSpotType.value color="white" small class="categoryChips" @click="store.commit('pickHotspotType', hotSpotType.value)" >
        <v-avatar left>
          <v-icon small >{{ hotSpotType.icon }}</v-icon>
        </v-avatar>
        {{ hotSpotType.name }}
      </v-chip>
    </v-chip-group>
    <v-dialog v-model="store.state.onboardingDialogVisible" persistent>
      <Onboarding></Onboarding>
    </v-dialog>
    <v-dialog v-model="store.state.stillHereDialogVisible" persistent v-if="store.state.userData.currentStayLocation">
      <StillHere></StillHere>
    </v-dialog>
    <div>
      <MapComponent ref="mapComponent"></MapComponent>
    </div>
    <v-overlay v-if="store.state.loading" opacity="0.6" style="z-index: 9999">
      <v-progress-circular indeterminate :size="50" :width="7" style="color: lightblue!important;"></v-progress-circular>
    </v-overlay>
    <v-dialog v-model="store.state.locationAddedDialogVisible">
      <v-card color="primary lighten-1" dark>
        <v-card-title style="word-break: normal">{{store.state.addedLocationName}} Was Added to Your Journey</v-card-title>
      </v-card>
    </v-dialog>
    <About></About>

  </div>
</template>


<script >

import MapComponent from './components/MapComponent';

import UserCard from "@/components/UserCard.vue";
import Onboarding from "@/components/Onboarding.vue";
import {store} from "@/store";
import About from "@/components/About.vue";
import StillHere from "@/components/StillHere.vue";
import ViewportControlMixin from '@/mixins/ViewportControlMixin';
export default {
  data() {
    return {
      user: '',
      isPublicStay: false,
      userData: {},
      currentStayDates: [],
      currentStayLocation: null,
      hotSpotTypes: [
        { value: "nomads choice", name: 'Nomads Choice', icon: 'mdi-star' },
        { value: 'cafe', name: 'Cafes', icon: 'mdi-coffee' },
        { value: 'restaurant', name: 'Restaurants', icon: 'mdi-silverware-fork-knife' },
        { value: 'coliving', name: 'Colivings', icon: 'mdi-sofa' },
        { value: 'coworking', name: 'Coworkings', icon: 'mdi-laptop' },
        { value: 'gym', name: 'Gyms', icon: 'mdi-weight-lifter' },
        { value: 'yoga', name: 'Yoga', icon: 'mdi-yoga' },
      ],
    }
  },
  mixins: [ViewportControlMixin],
  computed: {
    store() {
      return store
    },
    dateRangeText () {
      return this.stayDates.join(' ~ ')
    },
  },
  components: {
    StillHere,
    About,
    Onboarding,
    UserCard,
    MapComponent
  },
  methods: {
    refreshApp() {
      document.location = '/'
    },
    async reCenterMap() {
      // Function to handle successful retrieval of GPS position
      function handleSuccess(position) {
        let center = {
          lat: position.coords.latitude + Math.random() / 1000,
          lng: position.coords.longitude
        };
        store.commit('changeMapCenter', center);
        store.commit('changeMapZoom', 16 + Math.random() / 1000); // Adjust zoom level as needed
      }

      // Function to handle the existing logic if GPS fails or is not permitted
      function handleFallback() {
        if (store.state.userData.currentStayPosition) {
          let center = {
            lat: store.state.userData.currentStayPosition.lat + Math.random() / 1000,
            lng: store.state.userData.currentStayPosition.lng
          };
          store.commit('changeMapCenter', center);
          store.commit('changeMapZoom', 16 + Math.random() / 1000);
        }
      }

      // Check for geolocation permission status
      let permissionStatus = await navigator.permissions.query({ name: 'geolocation' });
      if (permissionStatus.state === 'granted' || permissionStatus.state === 'prompt') {
        // Try to use GPS to center the map
        navigator.geolocation.getCurrentPosition(handleSuccess, handleFallback);
      } else {
        // Fallback to the existing logic if permission is denied
        handleFallback();
      }
    }
  },
  async mounted() {
    await store.dispatch('getUserData')
    await store.dispatch('getTopLocations')
    await store.dispatch('getMyLocations')
    await store.dispatch('getLikedHotspots')
    await store.dispatch('getUserLikes')
    await store.dispatch('getUserContributions')
    if (store.state.userData.currentStayTense !== 'present') {
      store.state.onboardingDialogVisible = true
    }
    let d = new Date();
    d.setMonth(d.getMonth() - 1);
    if (store.state.userData.currentStayTense === 'present' && !store.state.userData.currentStayDates[1] && new Date(store.state.userData.currentStayLastUpdated) < d) {
      store.commit('setStillHereDialogVisibility', true)
    }
  },
}

</script>

<style>

@import url('https://fonts.cdnfonts.com/css/tisa-sans-pro');

#app {
  font-family: 'Tisa Sans Pro', sans-serif !important;
}

.v-button {
  text-transform: capitalize;
}
.headerText {
  font-weight: bold;
  font-family: 'Berlin Sans FB', sans-serif;
  font-size: 25px;
  text-shadow: #130d0d 1px 0 2px;
}
.categoryChips {
  background: white!important;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.2); /* This is a subtle shadow */

}

.centered-label .v-label {
  text-align: center;
  width: 100%; /* Ensures the label takes the full width of the text field */
  max-width: 100%;
}

.topBar {
  max-width: 450px;
  text-align-last: center;
  top: 0;
  position: fixed;
  width: 100vw;
  z-index: 99;
  border-bottom-left-radius: 15px!important;
  border-bottom-right-radius: 15px!important;
}
.topBarList {
  background-color: #def6f4!important;
  border-bottom-left-radius: 15px!important;
  border-bottom-right-radius: 15px!important;
}
body {
  background: white;
  overflow-y: hidden;
  -webkit-user-select: none; /* Disable text selection */
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  -webkit-touch-callout: none; /* Disable touch callouts */
}
#app {
  background: white;
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 0px;
  margin-bottom: 0px;
}

button {
  background-color: transparent;
  color: #fff;
  border: none;
  cursor: pointer;
  outline: none;
}

.v-card {
  word-break: normal;
}

.categoryChipsGroup {
  position: absolute;
  top: 68px;
  left: 3vw;
  z-index: 55;
  overflow: scroll;
  width: 97vw
}

.reCenterBtn {
  position: absolute;
  top: 75px;
  left: 3vw;
  z-index: 55;
}

.downOffset {
  top: 110px;
}

</style>
